module.exports = __webpack_public_path__ + "static/media/banner.563d5776.png";